module.exports = __webpack_public_path__ + "img/illu-kidneys.968bd679.svg";